import UF from './uf'

export default class Empresa {
  constructor(id, documento, nome, observacoes, status) {
    this.id = id
    this.documento = documento
    this.nome = nome
    this.uf = new UF()
    this.observacoes = observacoes
    this.status = status
  }
}
